import styled from '@emotion/styled'

export const PageWrapper = styled('div')({
    minHeight: '100vh',
})
